import { Button, MenuItem, Select, } from "@mui/material";
import axios from "axios";
import React from "react";
import { useState } from "react";
import { useEffect,useRef } from "react";
import { useContext } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AppContext } from "../context";
import { motion } from "framer-motion";
import Loading from "../Loading";

const MyCart = () => {
  const { UserId, IsLoggedIn } = useContext(AppContext);
  const [Value, setValue] = useState([]);
  const ItemQuantity = Value.Quantity
  console.log(ItemQuantity)
  const [Quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(true);
  const [text, settext] = useState("Retriving Cart Items....");
  const quantityRef = useRef(Quantity);
  const navigate = useNavigate();
  const token = localStorage.getItem("authtoken");
  axios.defaults.headers.common["authorization"] = `Bearer ${token}`;
  const handleChange = async(Id) => {
    settext("Updating Quantity....")
    setLoading(true)
    if (IsLoggedIn) {
      try {
        const response = await axios.put(`https://winterstore-backend.onrender.com/cart/${Id}`,{Quantity:quantityRef.current});
        if (response.status === 200) {
          getValues(UserId);
          setLoading(false)
          toast.info("Quantity successfully changed");
        }
      } catch (error) {
        toast.error("Server not available at this moment");
      }
    } else {
      toast.info("Login First to View");
    }
  };
  const handleDelete = async (id) => {
    settext("Removing item from cart....")
    setLoading(true)
    try {
      const response = await axios.delete(
        `https://winterstore-backend.onrender.com/cart/item/${id}`
      );
      if (response.status === 200) {
        toast.success("Item Deleted");
        getValues(UserId);
        setLoading(false)
      }
    } catch (error) {
      toast.error("error while deleting");
    }
  };
  useEffect(() => {
    getValues(UserId);
  }, [UserId]);
  const getValues = async (Id) => {
    if (IsLoggedIn) {
      try {
        const response = await axios.get(`https://winterstore-backend.onrender.com/cart/${Id}`);
        if (response.status === 200) {
          setValue(response.data);
          setLoading(false);
        }
      } catch (error) {
        toast.error("error occured");
      }
    } else {
      toast.info("Login First to View");
    }
  };
  const handleBuy = (id, Price) => {
    if (IsLoggedIn) {
      const data = `${id}&${Quantity}&${Price}`;
      navigate(`/Products/Checkout/${data}`);
    } else {
      toast.warning("Login First to Buy Item");
    }
  };
  createTheme(
    "custom",
    {
      text: {
        primary: "#FBFBFB",
        secondary: "#FFFFFF",
      },
      background: {
        default: "#101E2B",
      },
      context: {
        background: "#cb4b16",
        text: "#FFFFFF",
      },
      divider: {
        default: "#101E2B",
      },
      action: {
        button: "#FFFFFF",
        hover: "rgba(0,0,0,.08)",
        disabled: "rgba(0,0,0,.12)",
      },
    },
    "dark"
  );
  const columns = [
    {
      name: <h5>#</h5>,
      selector: (row, i) => <h6>{++i}</h6>,
      sortable: true,
    },
    {
      name: <h5>ProductName</h5>,
      selector: (row) => <h6>{row.ProductName}</h6>,
      sortable: true,
    },
    {
      name: <h5>Image</h5>,
      selector: (row) => (
        <img
          src={row.ProductImage}
          className="m-2"
          alt="product"
          height="100px"
          width="100px"
        />
      ),

      sortable: true,
    },
    {
      name: <h5>Quantity</h5>,
      selector: (row) => (
        <Select
          value={row.Quantity}
          onChange={(e)=>{
            setQuantity(e.target.value);
              quantityRef.current = e.target.value
    handleChange(row.Id)}}

          style={{
            width: "70px",
            height: "40px",
            color: "black",
            backgroundColor: "white",
          }}
        >
          <MenuItem value={1}>1</MenuItem>
          <MenuItem value={2}>2</MenuItem>
          <MenuItem value={3}>3</MenuItem>
          <MenuItem value={4}>4</MenuItem>
        </Select>
      ),
      sortable: true,
    },
    {
      name: <h5>TotalAmount</h5>,
      selector: (row) => <h6>{row.Quantity*row.Total}</h6>,
      sortable: true,
    },
    {
      name: <h5>DateAdded</h5>,
      selector: (row) => <h6>{row.date}</h6>,
      sortable: true,
    },
    {
      name: <h5>Actions</h5>,
      cell: (row) => (
        <>
          <Button
            variant="contained"
            className="m-1"
            style={{ backgroundColor: "#149686" }}
            onClick={() => handleDelete(row.Id)}
          >
            <i className="bi bi-trash fa fa-2x m-auto"></i>
          </Button>
          <Button
            variant="contained"
            className="m-1"
            style={{ backgroundColor: "#149686" }}
            onClick={() => handleBuy(row.Id, row.Total)}
          >
            <i className="bi bi-bag-heart-fill fa fa-2x m-auto"></i>
          </Button>
        </>
      ),
    },
  ];
 
    return (
      <>
      {loading ? (
        <div style={{marginTop:"320px"}}>
    <Loading text={text}/>
        </div>
      ) : (
        <motion.div
      initial={{ x: "-100vw" }}
      animate={{ x: 0 }}
      transition={{ duration: 2, type: "spring" }}
      className="container-fluid h-100"
      style={{ backgroundColor: "#101E2B" }}
    >
      <center>
        <h1 className="text-light p-3"><i className='bi bi-cart4 me-2'></i>My Cart Items</h1>
      </center>
      <div className="contianer-fluid mt-3 py-3 ">
        <DataTable
          columns={columns}
          data={Value}
          responsive={true}
          pagination={true}
          style={{ backgroundColor: "#101E2B" }}
          theme="custom"
        />
      </div>
    </motion.div>
      )}
      </>
    
  )
 
};

export default MyCart;
